export default "__VITE_ASSET__2gBH0oBl__"